import React, { ComponentProps } from 'react'
import Group from 'components/utils/Group'
import _BedbankLoyaltyPointsEarn from './_BedbankLoyaltyPointsEarn'

type InheritedPriceRowLoyaltyPointsProps = ComponentProps<typeof _BedbankLoyaltyPointsEarn>

function BedbankLoyaltyPointsEarn({ ...rest }: InheritedPriceRowLoyaltyPointsProps) {
  return (
    <Group direction="vertical" wrap="wrap" gap={4}>
      <_BedbankLoyaltyPointsEarn {...rest} />
    </Group>
  )
}

export default BedbankLoyaltyPointsEarn
